import { render } from "./numberPool.vue?vue&type=template&id=64f3fa73&scoped=true"
import script from "./numberPool.vue?vue&type=script&lang=js"
export * from "./numberPool.vue?vue&type=script&lang=js"

import "./numberPool.vue?vue&type=style&index=0&id=64f3fa73&scoped=true&lang=css"
import "./numberPool.vue?vue&type=style&index=1&id=64f3fa73&lang=css"
script.render = render
script.__scopeId = "data-v-64f3fa73"

export default script